<form [formGroup]="profileForm">
    <div class="cc6">
        <mat-form-field appearance="fill" color="primary">
            <mat-label multilang>Vorname</mat-label>
            <input matInput multilang deeplMode='placeholder' placeholder="Vorname" name="firstname"
                formControlName="firstname" required>
            <mat-error multilang>Vorname (Pflichtfeld)</mat-error>
        </mat-form-field>
    </div>
    <div class="cc6">
        <mat-form-field appearance="fill" color="primary">
            <mat-label multilang>Name</mat-label>
            <input matInput multilang deeplMode='placeholder' placeholder="Name" name="lastname"
                formControlName="lastname" required>
            <mat-error multilang>Name (Pflichtfeld)</mat-error>
        </mat-form-field>
    </div>
    <ng-container *ngIf="ismail else tel">
        <div class="cc6">
            <mat-form-field appearance="fill" color="primary">
                <mat-label multilang>Email</mat-label>
                <input matInput multilang deeplMode='placeholder' placeholder="Email" name="email"
                    formControlName="email" required>
                <mat-error multilang>Email (Pflichtfeld)</mat-error>
            </mat-form-field>
        </div>
        <div class="cc6">
            <mat-form-field appearance="fill" color="primary">
                <mat-label multilang>Telefonnummer</mat-label>
                <input matInput multilang deeplMode='placeholder' placeholder="Telefonnummer" name="tel"
                    formControlName="tel">
            </mat-form-field>
        </div>
    </ng-container>
    <ng-template #tel>
        <div class="cc6">
            <mat-form-field appearance="fill" color="primary">
                <mat-label multilang>Telefonnummer</mat-label>
                <input matInput multilang deeplMode='placeholder' placeholder="Telefonnummer" name="tel"
                    formControlName="tel" required>
                <mat-error multilang>Telefonnummer (Pflichtfeld)</mat-error>
            </mat-form-field>
        </div>
        <div class="cc6">
            <mat-form-field appearance="fill" color="primary">
                <mat-label multilang>Email</mat-label>
                <input matInput multilang deeplMode='placeholder' placeholder="Email" name="email"
                    formControlName="email">
            </mat-form-field>
        </div>
    </ng-template>
    <div class="cc6">
        <mat-form-field appearance="fill" color="primary">
            <mat-label multilang>Ihre Nachricht</mat-label>
            <textarea matInput name="message" placeholder="Ihre nachricht" formControlName="message"></textarea>
        </mat-form-field>
    </div>
</form>
<div class="cc6">
    <button class="fbtn-s" (click)="close()">Zurück</button>
    <button class="fbtn-se" (click)="send()">Senden</button>
</div>